export default __webpack_public_path__ + "static/media/icon_data.33d50951.svg";